<template>
  <div class="login">
    <div class="login-container">
      <div class="lang-option">
        <LangSelect />
      </div>
      <div class="top">
        <img src="@/assets/images/login/logoPetroNew.png" alt="Logo" />
        <div class="right">
          <p class="title">{{ $t("login.title") }}</p>
          <p class="description">{{ $t("login.description") }}</p>
          <div class="note">
            <span>{{ $t("login.note1") }}</span>
            &nbsp;
            <router-link to="/register">{{ $t("login.note2") }}</router-link>
          </div>
        </div>
      </div>

      <div class="form">
        <div class="input-wrap">
          <div class="label">{{ $t("login.labelUserName") }}</div>
          <input
            type="text"
            v-model="username"
            :placeholder="$t('login.plhUserName')"
          />
          <svg
            width="25"
            height="25"
            viewBox="0 0 512 512"
            v-if="!!username"
            @click="username = null"
          >
            <polygon
              fill="var(--ion-color-step-600, #666666)"
              points="405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798 375.202,405 405,375.202 285.798,256"
            />
          </svg>
        </div>

        <div class="input-wrap">
          <div class="label">{{ $t("login.labelPassWord") }}</div>
          <input
            :type="showPassword ? 'text' : 'password'"
            v-model="password"
            :placeholder="$t('login.plhPassWord')"
          />
          <svg
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            @click="showPassword = !showPassword"
            v-if="!showPassword"
          >
            <path
              d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
              fill="none"
            ></path>
            <path
              d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
            ></path>
          </svg>

          <svg
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            @click="showPassword = !showPassword"
            v-else
          >
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path
              d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
            ></path>
          </svg>
        </div>

        <md-button
          class="md-raised md-primary custom-button"
          @click="onSubmitLogin"
        >
          {{ $t("login.btnSubmit") }}
        </md-button>
      </div>

      <div class="slogan">
        Giao dịch an toàn, nhanh chóng, uy tín, bảo mật cao.
      </div>
    </div>
  </div>
</template>

<script>
import LangSelect from "@/components/LangSelect.vue";
import request from "@/request";
import { pricesSocket } from "@/sockets";

export default {
  name: "LoginView",
  components: {
    LangSelect,
  },
  data() {
    return {
      username: null,
      password: null,
      showPassword: false,
    };
  },
  methods: {
    onSubmitLogin() {
      if (!this.username || !this.password) {
        return this.$toast.error("Thông tin đăng nhập không được để trống");
      }
      const submitData = {
        username: this.username,
        password: this.password,
      };
      request
        .post("/api/users/login", submitData)
        .then((res) => {
          if (res.data.success == 1) {
            this.$toast.success(this.$t("login.successfully"));
            this.$store.commit("setToken", res.data.token);
            this.$socket.setupSocketConnection(res.data.token);
            pricesSocket.setupSocketConnection(res.data.token);
            localStorage.setItem("home_notification", "true");
            this.$router.push("/");
          }
        })
        .catch(this.$errorResponse.bind(this));
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  //background-color: #141414;
  //color: #666;
  color: rgba(255,255,255,0.8);
  text-shadow: 2px 3px 8px rgba(0,0,0,0.2);
  min-height: 100vh;
  background-image: url(@/assets/images/industry-cta-4.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 80px 15px;
  position: relative;
  height: 100vh;
  .lang-option {
    position: absolute;
    right: 15px;
    top: 50px;
  }
  .top {
    display: flex;
    justify-content: space-between;

    img {
      max-width: 400px;
      width: 50%;
      border-radius: 5px;
    }

    .right {
      width: 50%;
      text-align: right;
      align-self: end;
      padding-left: 10px;
      .title {
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        margin: 0;
      }
      .description {
        font-size: 8px;
        //color: #e6e6e6;
        color: rgba(255,255,255,0.8);
        line-height: 13px;
        margin: 3px 0 0;
      }
      .note {
        font-size: 12px;
        //color: #e6e6e6;
        color: rgba(255,255,255,0.8);
        a {
          color: #00c3ff;
        }
      }
    }
  }
  .form {
    margin-top: 50px;
    .input-wrap {
      margin-bottom: 10px;
      position: relative;
      .label {
        padding: 10px 0;
        font-weight: bold;
        font-size: 16px;
        line-height: 1.3;
        color: #fff;
        text-shadow: 3px 3px 8px rgba(0,0,0,0.1);
      }
      input {
        //background: #5151514d;
        background: #242424;
        border-radius: 5px;
        padding: 3px 0;
        width: 100%;
        outline: none;
        border: none;
        //color: #fff;
        color: rgba(255,255,255,0.8);
        padding: 12px 8px;
        font-size: 12px;
      }
      svg {
        position: absolute;
        right: 5px;
        bottom: 7px;
        cursor: pointer;
      }
    }
    .custom-button {
      //background-color: #ebcc7f !important;
      //color: #000 !important;
      margin: 0;
      width: 100%;
      margin-top: 30px;
      background: #181c27 !important;
      text-shadow: 2px 3px 8px rgba(0,0,0,0.2);
      color: #fff !important;
    }
  }
}

.slogan {
  text-align: center;
  position: absolute;
  bottom: 2%;
  color: #fff;
  left: 50%;
  transform: translateX(-50%);
}
</style>
